export const AUTHOR_TYPES = {
  AI: 'AI',
  USER: 'User'
};

export const SUGGESTIONS = [
  'Can you help me generate a report based on my uploaded data?',
  'What’s the best way to start analyzing this dataset?',
  'I need a summary of the most important insights—can you do that?'
];

export const WEB_PAGE_STATE_ENUMS = {
  Workflows: 'workflows',
  InputFundFiles: 'input-fund-files',
  JurisdictionsDrawer: 'jurisdictions-drawer',
  Extraction: 'extraction',
  LookupTables: 'lookup-tables',
  FundMappingDrawer: 'fund-mapping-drawer',
  Transformation: 'transformation',
  OutputTable: 'output-table',
  Report: 'report',
  ApproverDrawer: 'approver-drawer',
  Dashboard: 'dashboard',
  AutomationInputFund: 'automation-input-fund',
  AutomationFileMapping: 'automation-file-mapping',
  AutomationExtractionDashboard: 'automation-extraction-dashboard',
  AutomationTransformationDashboard: 'automation-transformation-dashboard'
};
